<template>
  <v-container pa-5>
    <v-layout row
              wrap>
      <template v-if="items && items.length > 0">
        <v-flex xs12
                pt-3>
          <h1>{{datasetTitle + (title ? ": " + title : "")}}</h1>
          <h2>Identyfikator obiektu: {{uri}}</h2>
        </v-flex>
        <v-flex xs12
                pt-3>
          <v-data-table :headers="headers"
                        :items="items"
                        :hide-default-footer="true"
                        :items-per-page="-1">
            <template v-slot:item.key="{ item }">
              <span v-html="item.key" />
            </template>
            <template v-slot:item.value="{ item }">
              <span v-html="item.value" />
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12
                pt-3>
          <Graph :item="graphItem"></Graph>
        </v-flex>
      </template>
      <template v-if="notExists">
        <h1>Obiekt nie istnieje</h1>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import Graph from "@/components/Graph";
import axios from "axios";

export default {
  name: "Rdf",
  components: { Graph },
  data () {
    return {
      datasets: [], graphItem: [], items: [], headers: [{ text: "Klucz", value: "key" }, { text: "Wartość", value: "value" }], uri: null, notExists: false
    }
  },
  computed: {
    title () {
      if (this.items && this.items.length > 0) {
        let titleBinding = this.items.find(binding => binding.key.includes('http://purl.org/dc/terms/title'));
        if (titleBinding)
          return titleBinding.value;
      }
    },
    datasetTitle () {
      if (this.$route.params.dataset) {
        let dataset = this.datasets.find(dataset => dataset.name === this.$route.params.dataset);
        if (dataset)
          return dataset.title;
      }
      return null;
    }
  },
  methods: {
    prepareLinkOrText (value) {
      if (value.startsWith("http")) {
        let dom = document.createElement("a");
        dom.setAttribute("href", value);
        dom.appendChild(document.createTextNode(value));
        return dom.outerHTML;
      }
      return value;
    }
  },
  created () {
    if (this.$route.params && this.$route.params.dataset && this.$route.params.id) {
      axios.get(this.$conf('VUE_APP_SERVER_URL') + "datasets").then(response => {
        if (response && response.data) {
          this.datasets = response.data;
          this.uri = document.location.href;
          let query = "SELECT * { <" + this.uri + "> ?predicate ?object }";
          axios
            .post(this.$conf('VUE_APP_SERVER_URL') + "search", {
              dataset: this.$route.params.dataset,
              query: query
            })
            .then(response => {
              if (response && response.data && response.data.results && response.data.results.bindings && response.data.results.bindings.length > 0) {
                this.items = response.data.results.bindings.map(binding => {
                  binding.key = this.prepareLinkOrText(binding.predicate.value);
                  binding.value = this.prepareLinkOrText(binding.object.value);
                  return binding;
                });
                this.graphItem = response.data.results.bindings.map(binding => {
                  binding.subject = { value: this.uri };
                  return binding;
                });
                this.graphItem.forEach(binding => {
                  if (binding.predicate.value === 'http://www.opengis.net/ont/geosparql#asWKT') {
                    binding.object.value = binding.object.value.substring(0, binding.object.value.indexOf("("));
                  }
                });
              } else {
                this.notExists = true;
              }
            })
            .catch(error => {
              if (error) {
                console.log(error);
              }
              this.notExists = true;
            });
        }
      });
    } else {
      this.notExists = true;
    }
  }
}
</script>